import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import render from './modules/render'
import ques from './modules/ques'
import theory from './modules/theory'
import roles from './modules/roles'
import rotate from './modules/rotate'
import website from './modules/website'
import orgRole from './modules/orgRole'
import enque from './modules/enque'
import competitionOnline from './modules/competitionOnline'
import virtual from './modules/virtual'
import center from './modules/center'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loading: false,
    studentListPage: '' // 学生一览page
  },
  mutations: {
    changeLoading (s, v) {
      s.loading = v;
    },
    changeStudentListPage (s, v) {
      s.studentListPage = v;
    }
  },
  modules: {
    app,
    settings,
    user,
    render,
    ques,
    theory,
    roles,
    website,
    rotate,
    orgRole,
    enque,
    competitionOnline,
    virtual,
    center
  },
  getters,
  actions: {
    // 获取权限列表
    getPermission ({commit}) {
      // return new Promise((resolve, reject) => {
      //   axios({
      //     url: '/privilege/queryPrivilege?id=' + sessionStorage.getItem('privId'),
      //     methods: 'get',
      //     headers: {
      //       token: sessionStorage.getItem('token'),
      //       name: sessionStorage.getItem('name')
      //     }
      //   }).then((res) => {
      //     // 存储权限列表
      //     commit('setList', res.data.cust.privileges[0].children);
      //     resolve(res.data.cust.privileges[0].children)
      //   }).catch(() => {
      //     reject()
      //   })
      // })
      this.$axios.post('/menu/allRoleMenuList').then((res) => {
        if (res.data.code === '0') {
          console.log(res, 'rdddddddddddddddd')
          commit('setList', res.data.data);
          // res.data.data.forEach(element => {
          //   this.expandedData.push(element.code)
          // });
          // this.treeData = res.data.data;
        }
      }).catch((res) => {
        this.$message.error(res.data.message)
      });
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js